let ApiRoot = ""
let StaticUrl = ""
let VideoUrl = ""
const BASE_UPLOAD = '/upload'

	// 生产环境
let CXWAPI = 'tpss'
ApiRoot = 'https://wx.cxiov.com/tpss'
StaticUrl = "https://www.cxiov.com/upload"
VideoUrl = "https://wx.cxiov.com"

const GaodeParams = {
	lng: 113.97975,
	lat: 22.5357,
	scale: 12,
	key: 'd02a13742967029af371001c3412cc4f'
}
const ApiHeardParams = {
	SALT: 'gmcx',
	APP_KEY: 'e3e24540-10b9-4b93-82f1-0b6921c25ec7',
	APP_SECRET: '03b78767b290fa42803ea5582fe39e68e00c74a0'
}
const SwiperList = [{
	id: 0,
	type: 'image',
	url: 'https://ossweb-img.qq.com/images/lol/web201310/skin/big84000.jpg'
}, {
	id: 1,
	type: 'image',
	url: 'https://ossweb-img.qq.com/images/lol/web201310/skin/big37006.jpg',
}, {
	id: 2,
	type: 'image',
	url: 'https://ossweb-img.qq.com/images/lol/web201310/skin/big39000.jpg'
}, {
	id: 3,
	type: 'image',
	url: 'https://ossweb-img.qq.com/images/lol/web201310/skin/big10001.jpg'
}, {
	id: 4,
	type: 'image',
	url: 'https://ossweb-img.qq.com/images/lol/web201310/skin/big25011.jpg'
}, {
	id: 5,
	type: 'image',
	url: 'https://ossweb-img.qq.com/images/lol/web201310/skin/big21016.jpg'
}, {
	id: 6,
	type: 'image',
	url: 'https://ossweb-img.qq.com/images/lol/web201310/skin/big99008.jpg'
}]
export default {
	ApiRoot,
	StaticUrl,
	SwiperList,
	GaodeParams,
	ApiHeardParams,
	BASE_UPLOAD,
	VideoUrl,
  CXWAPI
}



// WEBPACK FOOTER //
// ./src/config.js